import React from "react";
import Autenticacion from "./Autenticacion";
import Titulo from "../../App/components/core/atoms/Titulo";
export default function login() {
  return (
    <div>
      <Titulo
        label="HOSPITAL DE LA AMISTAD PERU-COREA SANTA ROSA II-2"
        limpiar="limpiar"
      />
      <Autenticacion />
    </div>
  );
}
